import React from 'react';
import Head from 'next/head';
import Page from '@/components/page';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

function App() {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Head, {
      children: /*#__PURE__*/_jsx("title", {
        children: "Motimate"
      })
    }), /*#__PURE__*/_jsx(Page, {})]
  });
}

export default App;